function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#dashboard-submissions_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.355 29.936l10 10c8.645-.581 15.806-6.646 18-14.775L26.452 12.258 11.355 29.936z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.258 9.677c-.71 0-1.29.581-1.29 1.29v18.065c0 .71.58 1.29 1.29 1.29h15.484c.71 0 1.29-.58 1.29-1.29V14.84l-5.161-5.162H12.258z",
  fill: "#FFFCF2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.871 9.677v5.162h5.161l-5.161-5.162zm-3.226 3.871h-6.451V20h6.451v-6.452zm1.29 3.871h4.517v-1.29h-4.517v1.29zm0 2.581h4.517v-1.29h-4.517V20zm-7.741 2.58h12.258v-1.29H14.194v1.29zm0 2.581h12.258v-1.29H14.194v1.29zm0 2.58h9.677v-1.29h-9.677v1.29z",
  fill: "#D4DAE1"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dashboard-submissions_svg__paint0_linear",
  x1: 0,
  y1: 40,
  x2: 40,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB77C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E95F48"
})));

function SvgDashboardSubmissions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "dashboard-submissions-a1b68739b92c9aec46d22d57c26a62d5.svg";
export { SvgDashboardSubmissions as ReactComponent };